import { useIllustrationColor } from '../hooks/useIllustrationColor.hook';
import type { IllustrationProps } from '../types/props.type';

// https://undraw.co/search/coffee-break
export const CoffeeBreakIllustration = ({
  color: pColor,
  title = 'En cours de construction',
}: Readonly<IllustrationProps>) => {
  const color = useIllustrationColor(pColor);

  return (
    <svg
      height="416.5"
      viewBox="0 0 743.70364 416.5"
      width="743.70364"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>{title}</title>
      <path
        d="M743.934,373.90525H729.79831a1.81781,1.81781,0,0,1-1.81577-1.64688l-2.82949-29.00177h23.42618L745.74975,372.258A1.81784,1.81784,0,0,1,743.934,373.90525Z"
        fill="#e6e6e6"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M748.54182,346.90525H725.19047a1.82648,1.82648,0,0,1-1.82433-1.82433v-4.37838a1.82647,1.82647,0,0,1,1.82433-1.82432h23.35135a1.82647,1.82647,0,0,1,1.82432,1.82432v4.37838A1.82648,1.82648,0,0,1,748.54182,346.90525Z"
        fill="#ccc"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M578.54867,342.75h-56v-17c17.6958-12.31482,33.37451-11.24438,54,1Z"
        fill={color}
        transform="translate(-228.14818 -241.75)"
      />
      <polygon
        fill="#ffb8b8"
        points="281.433 402.957 269.173 402.956 267.34 355.668 281.435 355.669 281.433 402.957"
      />
      <path
        d="M512.70726,656.59064l-39.53051-.00146v-.5a15.38605,15.38605,0,0,1,15.38647-15.38624h.001l24.1438.001Z"
        fill="#2f2e41"
        transform="translate(-228.14818 -241.75)"
      />
      <polygon
        fill="#ffb8b8"
        points="350.486 402.957 362.746 402.956 364.579 355.668 350.484 355.669 350.486 402.957"
      />
      <path
        d="M575.50745,640.70392l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38647,15.38624v.5l-39.53051.00146Z"
        fill="#2f2e41"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M578.9566,638.646a4.52007,4.52007,0,0,1-4.394-3.52247L544.17608,502.58446a1.45735,1.45735,0,0,0-1.46411-1.17383h-.00757a1.45832,1.45832,0,0,0-1.4602,1.18848L513.33966,634.24462a4.52164,4.52164,0,0,1-4.40235,3.5664H495.64459a4.50015,4.50015,0,0,1-4.49219-4.76562l9.90088-166.85547,3.98413-1.17871.07471.001,78.25806.68457,16.66748,166.67187a4.49788,4.49788,0,0,1-4.11646,4.92188l-16.604,1.34082Q579.13593,638.646,578.9566,638.646Z"
        fill="#2f2e41"
        transform="translate(-228.14818 -241.75)"
      />
      <circle cx="318.49104" cy="45.97086" fill="#ffb8b8" r="24.56103" />
      <path
        d="M531.59308,484.48388a42.39306,42.39306,0,0,1-12.72754-1.791,28.09708,28.09708,0,0,1-17.03809-14.375,4.50533,4.50533,0,0,1-.335-3.35449c2.70874-9.24512,15.79858-57.30078,7.44678-95.50293a40.48488,40.48488,0,0,1,5.75512-31.11426,39.97674,39.97674,0,0,1,25.927-17.43848l.00024-.001c1.38525-.27051,2.77808-.49219,4.13916-.66016a39.83567,39.83567,0,0,1,32.25781,10.61328,40.82033,40.82033,0,0,1,12.81568,32.36035l-6.41895,103.00391a4.46,4.46,0,0,1-2.398,3.70313C573.62481,473.80126,551.41778,484.48388,531.59308,484.48388Z"
        fill="#3f3d56"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M574.38563,269.64169A30.15573,30.15573,0,0,0,541.33294,251.058l7.744,6.2578c-9.62156.324-19.74953-.36491-26.61937,6.37933,2.18707-.06067,5.05355,4.61731,7.24062,4.55664-4.08894.08087-7.79673,2.95387-9.60282,6.62321a18.86524,18.86524,0,0,0-1.114,11.99709c.80759,4.00921,6.96813,13.40164,8.62633,17.14011-.28515-9.77015,18.94922-33.07441,28.3418-30.64234a25.77238,25.77238,0,0,0-11.90045,9.03527A34.90423,34.90423,0,0,1,564.75,279.01807a14.64993,14.64993,0,0,0,4.935.27623,6.02513,6.02513,0,0,0,3.57206-9.62851Z"
        fill="#2f2e41"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M529.90121,478.29883a4.50354,4.50354,0,0,1-1.802-.38037l-46.60059-20.34033a4.47019,4.47019,0,0,1-2.55322-5.27686l30.84985-116.53906a16.86544,16.86544,0,0,1,20.94068-11.90332l12.33544,3.5205-8.68383,146.68067a4.51257,4.51257,0,0,1-2.146,3.56982A4.46616,4.46616,0,0,1,529.90121,478.29883Z"
        fill={color}
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M616.14877,452.3l-2.0503-7.73-2.96972-11.24-1.43018-5.39-2.96972-11.21-21.43018-80.97a16.84727,16.84727,0,0,0-20.93994-11.9l-12.33008,3.52,6.10986,103.17.63037,10.77.39991,6.79v.01l.63964,10.71.9004,15.23a4.53042,4.53042,0,0,0,4.48974,4.24,4.58256,4.58256,0,0,0,1.80029-.38l46.59961-20.34A4.46627,4.46627,0,0,0,616.14877,452.3Z"
        fill={color}
        transform="translate(-228.14818 -241.75)"
      />
      <polygon
        fill="#ccc"
        points="381.55 186.19 330.621 199.57 329.99 188.8 378.581 174.98 381.55 186.19"
      />
      <polygon
        fill="#ccc"
        points="385.95 202.82 331.66 217.08 331.021 206.37 331.021 206.36 382.981 191.58 385.95 202.82"
      />
      <polygon
        fill="#ccc"
        points="308.181 191.12 307.55 201.69 257.601 186.81 260.53 175.75 308.181 191.12"
      />
      <polygon
        fill="#ccc"
        points="307.14 208.65 256.17 192.2 253.24 203.29 306.52 219.16 307.14 208.65"
      />
      <path
        d="M485.20719,461.454a10.7427,10.7427,0,0,0,7.04354-14.89081l23.962-75.22559-16.99143-3.55858-21.96889,73.75316a10.80091,10.80091,0,0,0,7.95476,19.92182Z"
        fill="#ffb8b8"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M516.87787,334.35575h0c4.879.4977,7.62331,5.98353,6.41025,12.81414L517.467,379.94827c-.43637,2.45712-2.45848,4.40264-4.13928,3.98249l-19.69048-4.922c-1.51517-.37875-2.07319-2.53134-1.21458-4.68526L504.24337,344.67C506.81048,338.23017,512.14754,333.87323,516.87787,334.35575Z"
        fill="#3f3d56"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M546.54867,241.75h0a31.99347,31.99347,0,0,1,31.97461,31h6.02539a2.00006,2.00006,0,0,1,2,2v8a2.00006,2.00006,0,0,1-2,2h-68a2.00006,2.00006,0,0,1-2-2v-9.00006A31.99981,31.99981,0,0,1,546.54867,241.75Z"
        fill={color}
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M550.37241,439.55485H536.23674A1.8178,1.8178,0,0,1,534.421,437.908l-2.82948-29.00177h23.42617l-2.82948,29.00142A1.81783,1.81783,0,0,1,550.37241,439.55485Z"
        fill="#e6e6e6"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M554.98025,412.55485H531.6289a1.82648,1.82648,0,0,1-1.82433-1.82432v-4.37838a1.82648,1.82648,0,0,1,1.82433-1.82432h23.35135a1.82647,1.82647,0,0,1,1.82432,1.82432v4.37838A1.82647,1.82647,0,0,1,554.98025,412.55485Z"
        fill="#ccc"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M543.60787,424.00154a10.52648,10.52648,0,0,1,1.62647.31919l37.64605-32.28411-2.20057-11.84534,17.44265-5.65757L604.056,395.125a8,8,0,0,1-3.40935,8.97531l-47.67746,30.1704a10.49709,10.49709,0,1,1-9.36135-10.26914Z"
        fill="#ffb8b8"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M582.97837,337.06325h0c5.21164-1.45893,10.4192,2.50789,12.16411,9.26592l8.3734,32.43014c.62768,2.431-.59144,5.01448-2.49556,5.28836l-22.30669,3.20857c-1.71648.2469-3.22884-1.51345-3.29175-3.8315l-.8661-31.9132C574.3677,344.58095,577.92556,338.47772,582.97837,337.06325Z"
        fill="#3f3d56"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M882.81118,544.22005a167.50624,167.50624,0,0,1-24.0754-44.93174,4.30257,4.30257,0,0,1,2.03179-5.17937l35.14526-18.83159a4.24661,4.24661,0,0,1,3.72552-.15124,4.31917,4.31917,0,0,1,2.46132,2.884,102.32827,102.32827,0,0,0,22.44563,41.89074,4.318,4.318,0,0,1,1.03823,3.64653,4.2466,4.2466,0,0,1-2.18939,3.01811L888.24888,545.3971A4.30257,4.30257,0,0,1,882.81118,544.22005Z"
        fill="#ccc"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M885.20949,542.41789a1.29855,1.29855,0,0,0,1.62208.335l35.1455-18.832a1.24595,1.24595,0,0,0,.65259-.897,1.31806,1.31806,0,0,0-.32495-1.12793,105.34006,105.34006,0,0,1-23.10693-43.125,1.31862,1.31862,0,0,0-.75806-.895,1.24691,1.24691,0,0,0-1.11035.0459l-35.14478,18.83154a1.29832,1.29832,0,0,0-.61963,1.53711,164.50739,164.50739,0,0,0,23.64453,44.12744Z"
        fill="#fff"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M898.22008,502.152l-19.14161,8.44958a3.00327,3.00327,0,0,1-3.956-1.533l-.47343-1.07252a3.00327,3.00327,0,0,1,1.533-3.956l19.1416-8.44958a3.00328,3.00328,0,0,1,3.956,1.533l.47344,1.07252A3.00328,3.00328,0,0,1,898.22008,502.152Z"
        fill="#ccc"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M905.22008,515.152l-19.14161,8.44958a3.00327,3.00327,0,0,1-3.956-1.533l-.47343-1.07252a3.00327,3.00327,0,0,1,1.533-3.956l19.1416-8.44958a3.00328,3.00328,0,0,1,3.956,1.533l.47344,1.07252A3.00328,3.00328,0,0,1,905.22008,515.152Z"
        fill="#ccc"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M860.32682,504.3196a10.74267,10.74267,0,0,1-2.06222-16.343l-8.0725-114.55784,23.253,2.25508.63868,112.18666a10.80091,10.80091,0,0,1-13.757,16.45913Z"
        fill="#a0616a"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M855.45584,411.91175a4.48168,4.48168,0,0,1-1.85871-3.40066L851.89328,377.635a12.39862,12.39862,0,0,1,24.34642-3.92684l7.48456,27.6049a4.50507,4.50507,0,0,1-3.16561,5.52077L859.268,412.60634A4.48292,4.48292,0,0,1,855.45584,411.91175Z"
        fill="#3f3d56"
        transform="translate(-228.14818 -241.75)"
      />
      <polygon
        fill="#a0616a"
        points="587.676 403.408 575.416 403.408 569.584 356.12 587.678 356.12 587.676 403.408"
      />
      <path
        d="M566.65909,399.90461H590.303a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H551.77223a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,566.65909,399.90461Z"
        fill="#2f2e41"
      />
      <polygon
        fill="#a0616a"
        points="633.676 403.408 621.416 403.408 615.584 356.12 633.678 356.12 633.676 403.408"
      />
      <path
        d="M612.65909,399.90461H636.303a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H597.77223a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,612.65909,399.90461Z"
        fill="#2f2e41"
      />
      <path
        d="M815.245,621.33534l-13.49634-.64355a4.499,4.499,0,0,1-4.28587-4.46289c-3.5581-54.91919-8.48584-113.80722-.94189-136.55664a4.50108,4.50108,0,0,1,5.14646-4.48535l53.99366,7.83789a4.47383,4.47383,0,0,1,3.85353,4.41992c6.89356,26.93641,7.20508,75.7819,6.94434,126.53418a4.5005,4.5005,0,0,1-4.5,4.53418h-14.55a4.47888,4.47888,0,0,1-4.44531-3.80078l-8.977-57.06739a3.5,3.5,0,0,0-6.93287.12793l-7.12622,59.60254a4.5171,4.5171,0,0,1-4.46875,3.96582Q815.35245,621.3412,815.245,621.33534Z"
        fill="#2f2e41"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M824.746,487.45058c-11.89942-6.61133-21.197-8.34863-25.67993-8.7959a4.41807,4.41807,0,0,1-3.05347-1.67285,4.47791,4.47791,0,0,1-.93115-3.40137l12.9375-96.05078a33.21915,33.21915,0,0,1,19.36352-25.957,32.30589,32.30589,0,0,1,31.39551,2.46094q.665.44238,1.30518.90332a33.17817,33.17817,0,0,1,12.63647,34.57324c-7.93359,32.45508-10.65869,85.66211-11.12451,95.999a4.46546,4.46546,0,0,1-2.918,4.00489,45.085,45.085,0,0,1-15.22583,2.71093A38.12459,38.12459,0,0,1,824.746,487.45058Z"
        fill="#3f3d56"
        transform="translate(-228.14818 -241.75)"
      />
      <circle cx="607.41949" cy="72.21977" fill="#a0616a" r="24.56103" />
      <path
        d="M852.94827,333.40134c-4.582,4.88078-13.09132,2.26066-13.68835-4.40717a8.05556,8.05556,0,0,1,.01013-1.5557c.30827-2.95357,2.01461-5.635,1.60587-8.7536a4.59041,4.59041,0,0,0-.8401-2.14891c-3.65125-4.88934-12.22228,2.18687-15.6682-2.2393-2.113-2.714.3708-6.98712-1.25066-10.02051-2.14-4.00357-8.47881-2.0286-12.45387-4.22115-4.42275-2.43949-4.15822-9.22525-1.24686-13.35269,3.55052-5.0336,9.77572-7.71952,15.92335-8.10661s12.25292,1.27475,17.9923,3.51145c6.52108,2.54134,12.98768,6.05351,17.00066,11.78752,4.88022,6.97317,5.34986,16.34794,2.90917,24.50175C861.757,323.35646,856.68993,329.41566,852.94827,333.40134Z"
        fill="#2f2e41"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M872.39877,357.28c-.43018-2.02-4.12012-4.78-9.39991-7.03a58.13527,58.13527,0,0,0-52.5,4.5,2.47961,2.47961,0,0,0-2.29,1.95l-17.76026,78.55-2.31006,10.23-1.52978,6.77-2.31006,10.2-1.23,5.45a2.5078,2.5078,0,0,0,2.22021,3.05l76.68995,6.62c.06982,0,.1499.01.21972.01a2.50026,2.50026,0,0,0,2.48-2.34l.73-11.11.78028-11.88.33984-5.15.77-11.85,5.10986-77.84V357.34Z"
        fill={color}
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M746.564,362.22439a10.52617,10.52617,0,0,1,.23929,1.64013l42.95745,24.782,10.44142-6.01094,11.13116,14.57228L788.99613,413.1284l-49.00791-38.66268a10.4958,10.4958,0,1,1,6.57573-12.24133Z"
        fill="#a0616a"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M791.295,386.53919a4.48166,4.48166,0,0,1,1.29315-3.65337l21.8634-21.86849a12.39862,12.39862,0,0,1,19.16808,15.51623l-15.57,23.9922a4.50506,4.50506,0,0,1-6.22447,1.3251l-18.5043-12.00853A4.48289,4.48289,0,0,1,791.295,386.53919Z"
        fill="#3f3d56"
        transform="translate(-228.14818 -241.75)"
      />
      <polygon
        fill="#ccc"
        points="639.15 193.5 638.38 205.35 559.99 203.73 562.3 193.5 639.15 193.5"
      />
      <polygon
        fill="#ccc"
        points="638.041 210.5 637.26 222.38 556.15 220.7 558.461 210.5 638.041 210.5"
      />
      <path
        d="M836.04867,266.25h0a31.99347,31.99347,0,0,0-31.97461,31h-6.02539a2.00006,2.00006,0,0,0-2,2v8a2.00006,2.00006,0,0,0,2,2h68a2.00006,2.00006,0,0,0,2-2v-9.00006A31.99981,31.99981,0,0,0,836.04867,266.25Z"
        fill={color}
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M336.26259,584.80615a39.063,39.063,0,0,1-37.72112-6.64474c-13.212-11.08918-17.35435-29.35854-20.72485-46.275l-9.96924-50.0356L288.719,496.22223c15.00965,10.33508,30.35744,21.00126,40.75007,35.97113s14.929,35.40506,6.57885,51.60314"
        fill="#e6e6e6"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M334.47849,645.38466c2.11249-15.38745,4.28468-30.97255,2.80288-46.52494-1.316-13.81219-5.52988-27.30283-14.10882-38.36422a63.81942,63.81942,0,0,0-16.37384-14.83745c-1.63739-1.03352-3.14442,1.56139-1.51416,2.59041a60.67173,60.67173,0,0,1,23.99889,28.9564c5.22489,13.28947,6.06393,27.77612,5.16355,41.89337-.54449,8.53723-1.69847,17.01851-2.86134,25.48891a1.55429,1.55429,0,0,0,1.04766,1.84518,1.50915,1.50915,0,0,0,1.84518-1.04766Z"
        fill="#f2f2f2"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M314.13137,618.15614a28.7553,28.7553,0,0,1-25.05474,12.93134c-12.68315-.60209-23.25684-9.45412-32.77516-17.85807l-28.15329-24.85722,18.63281-.8917c13.39961-.64126,27.14492-1.23941,39.90759,2.89278s24.53307,14.07691,26.8668,27.2873"
        fill="#e6e6e6"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M340.44853,654.23018c-10.16773-17.99115-21.9614-37.98626-43.03473-44.377a48.022,48.022,0,0,0-18.10109-1.869c-1.9218.1657-1.44191,3.1281.4764,2.96269a44.61387,44.61387,0,0,1,28.88649,7.64231c8.1449,5.544,14.48659,13.25166,19.85415,21.42526,3.28778,5.00658,6.23277,10.22556,9.17833,15.43753.94133,1.66564,3.69278.46329,2.74045-1.22181Z"
        fill="#f2f2f2"
        transform="translate(-228.14818 -241.75)"
      />
      <path
        d="M970.85182,658.25h-712a1,1,0,0,1,0-2h712a1,1,0,0,1,0,2Z"
        fill="#ccc"
        transform="translate(-228.14818 -241.75)"
      />
    </svg>
  );
};
